import { render, staticRenderFns } from "./AwardingTerms.vue?vue&type=template&id=07849446&scoped=true&"
import script from "./AwardingTerms.vue?vue&type=script&lang=js&"
export * from "./AwardingTerms.vue?vue&type=script&lang=js&"
import style0 from "./AwardingTerms.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AwardingTerms.vue?vue&type=style&index=1&id=07849446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07849446",
  null
  
)

export default component.exports